import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { WrapperLayout } from './WrapperLayout'

import { closeActiveModal } from 'data/ui/actions'

const enhance = connect(
  null,
  { closeActiveModal }
)

export const Wrapper = WrapperLayout

export class ModalWrapper extends Component {
  static propTypes = {
    closeActiveModal: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    preventClose: PropTypes.bool,
    modalRef: PropTypes.func,
    wide: PropTypes.bool,
    auto: PropTypes.bool,
    center: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = { isClosing: false }
  }

  onHide = event => {
    if (event) {
      event.preventDefault()
    }
    const { closeActiveModal, preventClose, onClose } = this.props
    if (preventClose === true) {
      return
    }
    if (onClose) {
      onClose()
    }

    this.setState({ isClosing: true })
    // Delay closing to ensure animation
    setTimeout(() => closeActiveModal(), 200 /* 200 ms */)
  }

  render() {
    const { children, ...otherProps } = this.props
    return (
      <Wrapper
        isOpen={!this.state.isClosing}
        onRequestClose={this.onHide}
        {...otherProps}
      >
        {React.cloneElement(children, { onModalClose: this.onHide })}
      </Wrapper>
    )
  }
}

export default enhance(ModalWrapper)
